import { createContext } from "react";
import { PaletteMode } from "@mui/material/styles";

export type ThemeModeContextValue = {
  themeMode: PaletteMode;
  toggleThemeMode: () => void;
};

const ThemeModeContext = createContext<ThemeModeContextValue>({
  themeMode: "light",
  toggleThemeMode: () => undefined,
});

export default ThemeModeContext;
